module.exports = __webpack_public_path__ + "static/media/bulkUploads.72d87f8d.svg";